import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: #000000;
  padding: 4rem 2rem 2rem;
  position: relative;
  overflow: hidden;
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const FooterColumn = styled.div`
  h3 {
    color: #FFD700;
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    position: relative;
    padding-bottom: 0.8rem;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 50px;
      height: 3px;
      background: #FF4500;
      border-radius: 2px;
    }
  }
  
  p {
    margin-bottom: 1.5rem;
    color: #FFFFE0;
  }
`;

const FooterLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.7rem;
  margin-bottom: 1.5rem;
  
  a {
    display: flex;
    align-items: center;
    font-size: 2rem;
    color: #FF4500;
    text-decoration: none;
    transition: color 0.2s;
    
    &:hover {
      color: #FFD700;
    }
  }
  
  h2 {
    font-size: 1.6rem;
    font-weight: 700;
    color: #FFD700;
    letter-spacing: 1px;
    margin: 0;
  }
`;

const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  
  li {
    margin-bottom: 0.8rem;
  }
  
  a {
    color: #FFFFE0;
    transition: color var(--transition-speed) var(--transition-effect),
                padding-left var(--transition-speed) var(--transition-effect);
    display: inline-block;
    
    &:hover {
      color: #FFD700;
      padding-left: 5px;
    }
    
    i {
      margin-right: 0.5rem;
      color: #FF8C00;
      font-size: 0.8rem;
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
`;

const SocialIcon = styled.a`
  color: #FFFFE0;
  background: rgba(139, 0, 0, 0.3);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 1.2rem;
  transition: all var(--transition-speed) var(--transition-effect);
  border: 1px solid rgba(255, 69, 0, 0.3);
  
  &:hover {
    background: #FF4500;
    color: #FFFFE0;
    transform: translateY(-5px);
  }
`;

const FooterBottom = styled.div`
  text-align: center;
  padding-top: 3rem;
  margin-top: 3rem;
  border-top: 1px solid rgba(255, 69, 0, 0.2);
  
  p {
    color: #FFFFE0;
    font-size: 0.9rem;
    
    a {
      color: #FF8C00;
      
      &:hover {
        color: #FFD700;
        text-decoration: underline;
      }
    }
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterColumn>
          <FooterLogo>
            <a href="#home">
              <i className="bx bx-code-alt"></i>
            </a>
            <h2>Rakshit</h2>
          </FooterLogo>
          <p>
            Creating elegant, responsive, and user-friendly web applications with modern technologies and best practices.
          </p>
          <SocialLinks>
            <SocialIcon href="https://github.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-github"></i>
            </SocialIcon>
            <SocialIcon href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin-in"></i>
            </SocialIcon>
            <SocialIcon href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-twitter"></i>
            </SocialIcon>
            <SocialIcon href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </SocialIcon>
          </SocialLinks>
        </FooterColumn>
        
        <FooterColumn>
          <h3>Quick Links</h3>
          <FooterLinks>
            <li>
              <a href="#home"><i className="fas fa-chevron-right"></i> Home</a>
            </li>
            <li>
              <a href="#projects"><i className="fas fa-chevron-right"></i> Projects</a>
            </li>
            <li>
              <a href="#skills"><i className="fas fa-chevron-right"></i> Skills</a>
            </li>
            <li>
              <a href="#contact"><i className="fas fa-chevron-right"></i> Contact</a>
            </li>
          </FooterLinks>
        </FooterColumn>
        
        <FooterColumn>
          <h3>Contact Info</h3>
          <FooterLinks>
            <li>
              <a href="mailto:contact@example.com">
                <i className="fas fa-envelope"></i> contact@example.com
              </a>
            </li>
            <li>
              <a href="tel:+11234567890">
                <i className="fas fa-phone"></i> +1 (123) 456-7890
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fas fa-map-marker-alt"></i> Mumbai, India
              </a>
            </li>
          </FooterLinks>
        </FooterColumn>
      </FooterContent>
      
      <FooterBottom>
        <p>
          &copy; {new Date().getFullYear()} Rakshit Waze. All Rights Reserved | Designed with <i className="fas fa-heart" style={{ color: 'var(--accent-color)' }}></i> by <a href="#home">Rakshit</a>
        </p>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;